export default import.meta.ROLLUP_FILE_URL_lokpwNoByRwlynVGkwUK2A